import { Button, Modal, Space, Table, message } from "antd";
import React from "react";
import CustomSelect from "../components/common/CustomSelect";
import Head from "../components/common/Head";
import CustomInput from "../components/common/Input";
import { isEnable5 } from "../components/common/IsEnabled";
import {
  addDataToSubcription,
  addSubscribtion,
  deleteSubscription,
  getAllMovies,
  getAllSeries,
  getAllSubscribtions,
  updateSubscription,
} from "../utils/api";

const AddSubcription = () => {
  const [open, setOpen] = React.useState(false);
  const [movie, setMovie] = React.useState([]);
  const [series, setSeries] = React.useState([]);
  const [ids, setIds] = React.useState([]);

  const getAllMoviesHandler = async () => {
    const [success, data] = await getAllMovies();
    if (success) {
      setMovie(data);
    }
  };

  const getAllSeriesHandler = async () => {
    const [success, data] = await getAllSeries();
    if (success) {
      setSeries(data);
    }
  };

  const [open2, setOpen2] = React.useState(false);

  const [data, setData] = React.useState({});
  const [update, setUpdate] = React.useState(false);
  const [add, setAdd] = React.useState({
    movie: false,
    series: false,
    id: "",
  });

  const [loading, setLoading] = React.useState(true);
  const [subscribtions, setSubscribtions] = React.useState([]);
  const [messageApi, contextHolder] = message.useMessage();

  const onCreateSubcription = async () => {
    setLoading(true);
    if (data.title && data.description && data.price && data.validity) {
      if (!update) {
        const [status, res] = await addSubscribtion(data);
        if (status) {
          messageApi.success("Subcription Created Successfully");
          getAllSubscribtionsHandler();
          setOpen(false);
        } else {
          messageApi.error("Subcription Not Created Successfully");
        }
      } else {
        const [status, res] = await updateSubscription(
          {
            title: data.title,
            description: data.description,
            price: data.price,
            validity: data.validity,
            identifier: data.identifier,
          },
          data._id
        );

        setOpen(false);
        getAllSubscribtionsHandler();
        setUpdate(false);
        setData({});
      }
    } else {
      messageApi.error("Please fill all the fields");
    }
    setLoading(false);
  };

  const getAllSubscribtionsHandler = async () => {
    setLoading(true);
    const [status, res] = await getAllSubscribtions();
    if (status) {
      setSubscribtions(res);
    } else {
      messageApi.error("Subscriptions Not Found");
    }
    setLoading(false);
  };
  const [loading3, setLoading3] = React.useState(false);

  React.useEffect(() => {
    getAllSubscribtionsHandler();
    getAllMoviesHandler();
    getAllSeriesHandler();
  }, []);

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      {contextHolder}
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        {" "}
        <Head
          title="Subscriptions"
          onClick={() => {
            setData({});
            setUpdate(false);
            setOpen(true);
          }}
          button={"Add Subscription"}
        />
        <Table
          loading={loading}
          dataSource={subscribtions}
          columns={[
            {
              title: "Actions",
              dataIndex: "actions",
              key: "actions",
              render: (text, record) => (
                <Space size="middle" direction="vertical">
                  <Button
                    style={{ width: "100%" }}
                    loading={loading3}
                    type="primary"
                    danger={record.isDisable}
                    onClick={async () => {
                      setLoading3(true);
                      const data = {
                        isDisable: !record.isDisable,
                      };
                      const [success, response] = await updateSubscription(
                        data,
                        record._id
                      );
                      if (success) {
                        messageApi.success(" updated successfully");
                        getAllSubscribtionsHandler();
                      }
                      setLoading3(false);
                    }}
                  >
                    {record.isDisable ? "Enable" : " Disable"}
                  </Button>
                  <Button
                    type="primary"
                    style={{ width: "100%" }}
                    onClick={() => {
                      setOpen(true);
                      setUpdate(true);
                      setData(record);
                    }}
                  >
                    Edit Subcription
                  </Button>

                  <Button
                    type="primary"
                    style={{ width: "100%" }}
                    danger
                    onClick={async () => {
                      Modal.confirm({
                        title:
                          "Are you sure you want to delete this subscription?",

                        content: "This action cannot be undone.",
                        okText: "Delete",
                        okType: "danger",
                        cancelText: "Cancel",
                        onOk: async () => {
                          const [success, data] = await deleteSubscription(
                            record._id
                          );
                          if (success) {
                            messageApi.success(
                              "Subscription Deleted Successfully"
                            );
                            getAllSubscribtionsHandler();
                          } else {
                            messageApi.error(
                              "Subscription Not Deleted Successfully"
                            );
                          }
                        },
                        onCancel() {
                          console.log("Cancel");
                        },
                      });
                    }}
                  >
                    Delete
                  </Button>
                </Space>
              ),
            },
            {
              title: "Title",
              dataIndex: "title",
              key: "title",
            },
            isEnable5,
            {
              title: "Description",
              dataIndex: "description",
              key: "description",
            },
            {
              title: "Price",
              dataIndex: "price",
              key: "price",
            },
            {
              title: "Validity",
              dataIndex: "validity",
              key: "validity",
            },
          ]}
        />
        <Modal
          open={open2}
          onCancel={() => {
            setOpen2(false);
            setAdd({});
            setMovie([]);
            setSeries([]);
            setIds([]);
          }}
          confirmLoading={loading}
          onOk={async () => {
            setLoading(true);
            const [status, res] = await addDataToSubcription({
              [add.movie ? "movieIds" : "seriesIds"]: ids,
              type: add.movie ? "Movie" : "Series",
              subscriptionId: add.id,
            });
            if (status) {
              messageApi.success("Data Added Successfully");
              setOpen2(false);
              setAdd({});
              setMovie([]);
              setIds([]);
              setSeries([]);
              getAllSubscribtionsHandler();
            } else {
              messageApi.error("Data Not Added Successfully");
            }
            setLoading(false);
          }}
          title={add.movie ? "Add Movies" : "Add Series"}
        >
          <CustomSelect
            mode="multiple"
            onChange={(e) => {
              console.log(e);
              setIds(e);
            }}
            name="Select Movies/ Series"
            value={ids}
            style={{ width: "100%" }}
            options={
              add.movie
                ? movie?.map((movie) => ({
                    value: movie._id,
                    label: movie.name,
                  }))
                : series.map((series) => ({
                    value: series._id,
                    label: series.name,
                  }))
            }
          />
        </Modal>
        <Modal
          open={open}
          onCancel={() => {
            setOpen(false);
            setUpdate(false);
            setData({});
          }}
          confirmLoading={loading}
          onOk={async () => {
            setLoading(true);
            if (update) {
              const [status, res] = await updateSubscription(data, data._id);
              console.log(status, res);
              if (status) {
                messageApi.success("Subcription Updated Successfully");
                getAllSubscribtionsHandler();
                setOpen(false);
                setUpdate(false);
                setData({});
              } else {
                messageApi.error("Subcription Not Updated Successfully");
              }
            } else {
              const [status, res] = await addSubscribtion(data);
              if (status) {
                messageApi.success("Subcription Created Successfully");
                getAllSubscribtionsHandler();
                setOpen(false);
                setUpdate(false);
                setData({});
              } else {
                messageApi.error("Subcription Not Created Successfully");
              }
            }
            setLoading(false);
          }}
          title={update ? "Update Subcription" : "Create Subcription"}
        >
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <CustomInput
              value={data.title}
              onChange={(e) =>
                setData((prev) => ({ ...prev, title: e.target.value }))
              }
              name="Title"
            />
            <CustomInput
              value={data.description}
              onChange={(e) =>
                setData((prev) => ({ ...prev, description: e.target.value }))
              }
              name="Description"
            />
            <CustomInput
              value={data.price}
              onChange={(e) =>
                setData((prev) => ({ ...prev, price: e.target.value }))
              }
              name="Price"
            />
            <CustomInput
              value={data.identifier}
              onChange={(e) =>
                setData((prev) => ({ ...prev, identifier: e.target.value }))
              }
              name="Identifier"
            />
            <CustomInput
              value={data.validity}
              onChange={(e) =>
                setData((prev) => ({ ...prev, validity: e.target.value }))
              }
              name="Validity"
            />
          </Space>
        </Modal>
      </Space>
    </Space>
  );
};

export default AddSubcription;
